import { render } from "./BulkSkipTracking.vue?vue&type=template&id=45dd199c&scoped=true"
import script from "./BulkSkipTracking.vue?vue&type=script&lang=ts"
export * from "./BulkSkipTracking.vue?vue&type=script&lang=ts"

import "./BulkSkipTracking.vue?vue&type=style&index=0&id=45dd199c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-45dd199c"

export default script